import { gql } from "@apollo/client";

export const PARCEL_TASK = gql`
subscription ParcelTaskById($id: uuid!,$task_type_id:uuid, $task_start_date:timestamptz, $task_end_date:timestamptz) {
    parcels_by_pk( id: $id ) {
    parcel_name
    widget_parcel_columns
    widget_parcel_location_density
    widget_parcel_rows
    zones_aggregate {
      nodes {
        zone_moniker
        id
        widget_zone_row
        widget_zone_column
        locations_aggregate {
          nodes {
            location_moniker 
            id
            worker_plans(where: {task_type: {}, task_start_date: {_gte: $task_start_date}, task_end_date: {_lte:$task_end_date}, task_type_id: {_eq: $task_type_id}}) {
              worker {
                first_name
                last_name
              }
              task_start_date
              task_end_date
              task_sequence
            }
            worker_actuals {
              task_state
            }
          }
        }
      }
  } 
    }
}
`;

export const PARCEL_WORKER_TASK= gql`
subscription ParcelTaskById($id: uuid!, $worker_id:uuid, $task_start_date:timestamptz, $task_end_date:timestamptz) {
  parcels_by_pk(id:$id) {
    parcel_name
    widget_parcel_columns
    widget_parcel_location_density
    widget_parcel_rows
    zones(
      where: {
        locations: {
          _or: [
            { worker_plans: { worker_id: { _eq:$worker_id } } },
            { worker_actuals: { worker_plan: { worker_id: { _eq: $worker_id } } } }
          ]
        }
      }
    ) {
      zone_moniker
      widget_zone_row
      widget_zone_column
      locations_aggregate(
        where: {
          _or: [
            { worker_plans: { worker_id: { _eq: $worker_id } } },
            { worker_actuals: { worker_plan: { worker_id: { _eq: $worker_id} } } }
          ]
        }
      ) {
        nodes {
          location_moniker
          id
          worker_plans(
            where: {
              worker: { id: { _eq:$worker_id} },
              task_start_date: { _gte:  $task_start_date },
              task_end_date: { _lte:  $task_end_date }
            }
          ) {
            id
            worker {
              id
              first_name
              last_name
            }
            task_start_date
            task_end_date
            task_sequence
            task_type {
              task_type_description
            }
          }
          worker_actuals(
            where: {
              worker_plan: { worker_id: { _eq: $worker_id} }
            }
          ) {
            id
            worker_plans_id
            task_state
            tasks_duration
            scan_time
            last_location_id
            reporting_user_id
            notes
            modality
            modified_date
          }
          widget_in_zone_row
        }
      }
    }
  }
}
`